module.exports = __webpack_public_path__ + "img/ueberdachung.0c9658ab.webp";